import CodeSnippet from "src/components/general/CodeSnippet/CodeSnippet";
import { toolCallInputDisplayText } from "../../ToolCallIndicator.utils";
import ToolCallIndicatorNodeLabel from "../ToolCallIndicatorNode/components/ToolCallIndicatorNodeLabel/ToolCallIndicatorNodeLabel";

interface ToolCallIndicatorInputBlockProps {
  input: Record<string, unknown>;
  hasInputParseError?: boolean;
  withInputLabel: boolean;
  className?: string;
}

export default function ToolCallIndicatorInputBlock({
  input,
  hasInputParseError,
  withInputLabel,
  className,
}: ToolCallIndicatorInputBlockProps) {
  const codeSnippet = (
    <CodeSnippet
      code={toolCallInputDisplayText(input, hasInputParseError)}
      sentiment="neutral"
      className="max-h-72"
    />
  );

  if (!withInputLabel) return codeSnippet;

  return (
    <div className={className}>
      <ToolCallIndicatorNodeLabel
        className={hasInputParseError ? "text-error" : "text-neutral"}
      >
        Input{hasInputParseError && " (parse error)"}
      </ToolCallIndicatorNodeLabel>
      {codeSnippet}
    </div>
  );
}
